import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import Swiper from 'swiper/';
import Navigation from 'swiper/modules/navigation.min.mjs';
import Thumbs from 'swiper/modules/thumbs.min.mjs';
import EffectFade from 'swiper/modules/effect-fade.mjs';

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Thumbs = Thumbs;
window.EffectFade = EffectFade;

import dragScroll from "dragscroll/dragscroll";
window.dragScroll = dragScroll;

// flatpickr removed — using custom Datepicker component
